import React, { useEffect } from 'react';
import {
    Card,
    ExamTable,
    MappedExamStatuses,
    MultiSelectSection,
    IMultiSelectSectionFetchList,
    PaginationData,
} from 'components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { IExam } from '../../api/ApiClient';
import { IRootState, Dispatch } from '../../redux/store/configureStore';
import { NeedingAttentionMappedExamStatuses } from '../../helpers/enums';
import { useLocalErrorHandler } from 'hooks';
import { IGetExamsList } from '../../redux/models/exams';

const ExamListContainer = ({
    getExams, setErrorHandler, examList, needingAttentionExamIds, onPush, apiError,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);
    const [fetchProps, setFetchProps] = React.useState<IGetExamsList | undefined>(undefined);

    useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getExams({});
            setProcessing(false);
        };

        fetch();
    }, []);

    const HEADER = [
        'Дата и время',
        'Квалификация',
        'Тип',
        'Статус',
    ];

    const handleChangePagination = (newPagination: PaginationData) => {
        getExams({
            ...fetchProps,
            ...newPagination,
            pageSize: newPagination.perPage,
        });
    };

    const handleChooseExam = (id?: string) => {
        if (!id) return;
        onPush(`/exam/${id}?from=exam-list`);
    };

    const getExamData = (exam: IExam) => ({
        ...exam,
        status: needingAttentionExamIds.indexOf(exam.id) !== -1 ? NeedingAttentionMappedExamStatuses[exam.status] : MappedExamStatuses[exam.status],
        name: exam.qualificationTitle,
        examType: exam.type,
    });

    const fetchList = (data: IMultiSelectSectionFetchList) => {
        const props: IGetExamsList = {
            sortOrder: data.sortOrder === null ? undefined : data.sortOrder,
            ...data,
        };

        setFetchProps(props);
        getExams({ ...props });
    };

    return (
        <Card
          withoutPadding
          title="Список экзаменов"
          category="Список всех экзаменов с вашим участием"
          apiError={apiError}
          showLoader={processing}
        >
            <MultiSelectSection
              fetchList={fetchList}
              examSelectStatusName="ExamListFilters"
            />
            <ExamTable
              header={HEADER}
              tableRows={examList && examList.items ? examList.items.map(getExamData) : []}
              onChooseExam={handleChooseExam}
              pagination={examList}
              onChangePagination={handleChangePagination}
              placeholderTitle="Нет экзаменов в списке"
              placeholderText="Здесь будут отображаться все экзамены, ожидающие обработки"
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    examList: state.exams.examsList,
    needingAttentionExamIds: state.exams.needingAttentionExamIds,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getExams: dispatch.exams.fetchExamFilteredList,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ExamListContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
